<div class="content-main form-field-density-4" >    
    <div class="content">
        <mat-grid-list cols="4" rowHeight="150px">
            <mat-grid-tile
                *ngFor="let data of attribs|arrayFilter:'type':(!variacao?'PRODUCT_PROPERTY':'SALES_PROPERTY'):false:true:null">
                <div class="data-card">
                    <ng-container  [ngTemplateOutlet]="main" [ngTemplateOutletContext]="{$implicit:data}" ></ng-container>            
                </div>
            </mat-grid-tile>
        </mat-grid-list>
    </div>
    <actions-buttons [buttonList]="buttonList"></actions-buttons>
</div>

<ng-template #main let-item let-type="type" >
    <mat-card  appearance="outlined"  [ngClass]="{'cardnon':!isRequired(item), 'cardred':isRequired(item)}" >
        <mat-card-header>
            <mat-icon class="close" (click)="deleteItem(item)" *ngIf="!isRequired(item)">close</mat-icon>
            <mat-card-title [matTooltip]="item.name">
            {{item.name}}
            <mat-icon class="warn" matTooltip="Esse atributo é de variação, não preencher se o produto tiver variação." *ngIf="isVariant(item)">warning</mat-icon>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="card-content">
            <div class="select-container" *ngIf="item.is_customizable && !item.is_multiple_selection && item.values!= null && item.values.length > 0" class="full"> 
                <nz-select nzMode="default" [(ngModel)]="item.dataValue" [nzSize]="'default'" nzShowSearch class="full"
                    [nzLabelProperty]="'name'"

                    nzPlaceHolder="{{'please.select'|translateTA}}"
                    [compareWith]="compareValue"
                    >
                    @for (option of item.values; track option) {
                        <nz-option [nzLabel]="option.name" [nzValue]="option" [nzKey]="option.id"></nz-option>
                    }
                </nz-select>
            </div>
            <div class="select-container" *ngIf="item.is_customizable && item.is_multiple_selection && item.values!= null && item.values.length > 0" class="full">
                <nz-select class="full"
                    [nzMaxTagCount]="1"
                    [nzLabelProperty]="'name'"
                    nzMode="tags"
                    nzAllowClear
                    [compareWith]="compareValue"
                    nzPlaceHolder="{{'please.select'|translateTA}}"
                    [(ngModel)]="item.dataValue"
                    [nzCustomTemplate]="custom"

                    >
         
                        @for (option of item.values; track option) {
                            <nz-option [nzLabel]="option.name" [nzValue]="option" [nzKey]="option.id"></nz-option>
                        }

                    </nz-select>
                     <ng-template #custom let-selected>
                        {{ selected?.nzLabel ||  'Valor desconhecido' }}
                    </ng-template>
            </div>

            <div class="select-container" *ngIf="!item.is_customizable && !item.is_multiple_selection && item.values!= null && item.values.length > 0" class="full"> 
                <nz-select nzMode="default"  [(ngModel)]="item.dataValue" [nzSize]="'default'" nzShowSearch  class="full"
                    nzPlaceHolder="{{'please.select'|translateTA}}"
                    [compareWith]="compareValue">
                    @for (option of item.values; track option) {
                        <nz-option [nzLabel]="option.name" [nzValue]="option" [nzKey]="option.id"></nz-option>
                    }
                </nz-select>
            </div>
            <div class="select-container" *ngIf="!item.is_customizable && item.is_multiple_selection && item.values!= null && item.values.length > 0" class="full">
                <nz-select class="full"
                    nzMode="multiple"
                    nzAllowClear
                    nzPlaceHolder="{{'please.select'|translateTA}}"
                    [(ngModel)]="item.dataValue"
                    [compareWith]="compareValue"
                    >
                    @for (option of item.values; track option) {
                        <nz-option [nzLabel]="option.name" [nzValue]="option" [nzKey]="option.id"></nz-option>
                    }
                </nz-select>
            </div>
            <div class="select-container" *ngIf="!item.is_customizable  && item.values== null" class="full">
                <input nz-input [(ngModel)]="item.dataValue" size="small" placeholder="{{'please.edit'|translateTA}}" class="full"/>  
            </div>
            <div class="select-container" *ngIf="item.is_customizable  && item.values== null" class="full">
                <input nz-input [(ngModel)]="item.dataValue" size="small" placeholder="{{'please.edit'|translateTA}}" class="full"/>
            </div>

        </mat-card-content>
    </mat-card>
</ng-template>